import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { joinUrl } from 'src/app/_helpers/urls';
import { ClipboardService } from 'src/app/_services/clipboard.service';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { environment } from 'src/environments/environment';

/**
 * Copies shareable links to an insurance flow, for the admin platform and the partner platform.
 */
@Component({
  selector: 'app-copy-flow-links',
  standalone: true,
  imports: [CommonModule, IconsModule, NgbTooltipModule],
  templateUrl: './copy-flow-links.component.html',
  styleUrl: './copy-flow-links.component.css',
})
export class CopyFlowLinksComponent {
  @Input() flowId: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly clipboardService: ClipboardService,
    @Inject(APP_BASE_HREF) private readonly baseHref: string
  ) {}

  /** Hides the partner button until the environment placeholders have been replaced. */
  protected get partnerLinkAvailable(): boolean {
    return (
      !!environment.PARTNER_APP_URL &&
      !environment.PARTNER_APP_URL.startsWith('TODO')
    );
  }

  protected copyAdminLink(): void {
    if (!this.flowId) {
      return;
    }

    // Built from the router so the segment encoding stays correct if the route ever changes shape,
    // and from APP_BASE_HREF so the link points at the locale the user is currently browsing.
    const path = this.router.serializeUrl(
      this.router.createUrlTree(['/proposal/flow', this.flowId])
    );
    const origin = window.location.origin + this.baseHref.replace(/\/$/, '');
    this.clipboardService.copy(
      origin + path,
      $localize`Lien admin copié avec succès`
    );
  }

  protected copyPartnerLink(): void {
    if (!this.flowId || !this.partnerLinkAvailable) {
      return;
    }

    this.clipboardService.copy(
      joinUrl(
        environment.PARTNER_APP_URL,
        environment.PARTNER_APP_FLOW_PATH,
        encodeURIComponent(this.flowId)
      ),
      $localize`Lien partenaire copié avec succès`
    );
  }
}
